import { useEffect, useLayoutEffect } from 'react'

/**
 *
 * on server it return useEffect, on client useLayoutEffect
 * prevents useLayoutEffect server-side console warning
 */
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect
